(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec9e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec9e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d7rjb", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d11cac84a4afb7$export$2e2bcd8739ae039);
class $98d11cac84a4afb7$var$VideoUtils {
    constructor(){
        // Initialize caches for players
        this.vimeoPlayers = new Map();
        this.youtubePlayers = new Map();
        this.videoMuteStatus = new Map(); // Track muted status per video/iframe
    }
    // Push video interaction to the GTM data layer
    pushVideoEventToDataLayer(eventAction, videoType, videoLabel) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "video_interaction",
            video_action: eventAction,
            video_type: videoType,
            video_label: videoLabel
        });
    //console.log(`Event pushed: ${eventAction}, Type: ${videoType}, Label: ${videoLabel}`);
    }
    // Enable YouTube API if not already enabled
    enableYouTubeAPI(iframe) {
        if (iframe.src.includes("youtube.com") && !iframe.src.includes("enablejsapi=1")) iframe.src += (iframe.src.includes("?") ? "&" : "?") + "enablejsapi=1";
    }
    // Load YouTube API dynamically
    loadYouTubeAPI() {
        return new Promise((resolve)=>{
            if (window.YT && window.YT.Player) resolve(); // API already loaded
            else {
                const script = document.createElement("script");
                script.src = "https://www.youtube.com/iframe_api";
                script.async = true;
                window.onYouTubeIframeAPIReady = ()=>resolve(); // Wait for API to load
                document.head.appendChild(script);
            }
        });
    }
    // Load Vimeo Player API once (PHP also enqueues it; this waits or loads as fallback)
    loadVimeoAPI() {
        if (typeof Vimeo !== "undefined" && Vimeo?.Player) return Promise.resolve();
        if (this._vimeoApiPromise) return this._vimeoApiPromise;
        this._vimeoApiPromise = new Promise((resolve, reject)=>{
            const src = "https://player.vimeo.com/api/player.js";
            const existing = document.querySelector(`script[src*="player.vimeo.com/api/player.js"]`);
            const onReady = ()=>{
                if (typeof Vimeo !== "undefined" && Vimeo?.Player) resolve();
                else reject(new Error("Vimeo Player API failed to initialize"));
            };
            if (existing) {
                if (typeof Vimeo !== "undefined" && Vimeo?.Player) {
                    resolve();
                    return;
                }
                existing.addEventListener("load", onReady, {
                    once: true
                });
                existing.addEventListener("error", reject, {
                    once: true
                });
                return;
            }
            const script = document.createElement("script");
            script.src = src;
            script.async = true;
            script.onload = onReady;
            script.onerror = reject;
            document.head.appendChild(script);
        });
        return this._vimeoApiPromise;
    }
    // Initialize YouTube Player and cache it
    async initializeYouTubePlayer(iframe, eventHandlers) {
        await this.loadYouTubeAPI();
        const youtubePlayer = new YT.Player(iframe, {
            events: {
                onReady: eventHandlers.onReady || (()=>{}),
                onStateChange: eventHandlers.onStateChange || (()=>{})
            }
        });
        this.youtubePlayers.set(iframe, youtubePlayer);
        return youtubePlayer;
    }
    // Setup progress tracking for both Vimeo and YouTube players
    setupProgressTracking(player, type, source) {
        const progressMarkers = {
            25: false,
            50: false,
            75: false,
            99: false
        };
        const trackProgress = (percentage)=>{
            Object.keys(progressMarkers).forEach((marker)=>{
                if (percentage >= marker && !progressMarkers[marker]) {
                    this.pushVideoEventToDataLayer(`progress_${marker}`, type, source);
                    progressMarkers[marker] = true;
                }
            });
        };
        if (type === "Vimeo") player.on("timeupdate", (data)=>{
            const percentage = data.seconds / data.duration * 100;
            trackProgress(percentage);
        });
        else if (type === "YouTube") {
            const interval = setInterval(()=>{
                const percentage = player.getCurrentTime() / player.getDuration() * 100;
                trackProgress(percentage);
                if (percentage >= 99) clearInterval(interval);
            }, 1000);
        }
    }
    // Handle FancyBox close and reset video playback
    setupFancyBoxCloseHandler(iframe, type, playButton = null, callback = null) {
        const player = type === "Vimeo" ? this.getVimeoPlayer(iframe) : this.getYouTubePlayer(iframe);
        jQuery(document).on("afterClose.fb", async ()=>{
            try {
                if (player) type === "Vimeo" ? await player.play() : player.playVideo();
                if (playButton) {
                    playButton.textContent = "Pause";
                    playButton.classList.add("playing");
                }
                if (typeof callback === "function") callback();
            } catch (error) {}
        });
    }
    // Play and control mute for Vimeo Video
    async playAndControlVimeo(iframe, mute = false) {
        try {
            await this.loadVimeoAPI();
        } catch (error) {
            return;
        }
        const player = this.getVimeoPlayer(iframe);
        if (!player) return;
        try {
            await player.ready();
            const isPaused = await player.getPaused();
            await player.setVolume(mute ? 0 : 1);
            if (isPaused) await player.play();
        } catch (error) {}
        this.setupProgressTracking(player, "Vimeo", iframe.src);
    }
    // Play YouTube video
    async playYouTube(iframe, eventHandlers = {}) {
        this.enableYouTubeAPI(iframe);
        const player = await this.initializeYouTubePlayer(iframe, eventHandlers);
        player.playVideo();
        this.setupProgressTracking(player, "YouTube", iframe.src);
    }
    // Pause Vimeo video
    async pauseVimeo(iframe) {
        try {
            await this.loadVimeoAPI();
        } catch (error) {
            return;
        }
        const player = this.getVimeoPlayer(iframe);
        if (!player) return;
        try {
            await player.pause();
        } catch (error) {}
    }
    // Pause YouTube video
    async pauseYouTube(iframe) {
        const player = this.youtubePlayers.get(iframe);
        if (player) try {
            player.pauseVideo();
        } catch (error) {}
    }
    async isVimeoPlaying(iframe, maxAttempts = 10, interval = 200) {
        try {
            await this.loadVimeoAPI();
        } catch (error) {
            return false;
        }
        const player = this.getVimeoPlayer(iframe);
        if (!player) return false;
        try {
            await player.ready(); // Ensure the player is initialized
            let attempts = 0;
            while(attempts < maxAttempts){
                const isPaused = await player.getPaused();
                if (!isPaused) //console.log(`Vimeo video is playing (after ${attempts + 1} attempts): ${iframe.src}`);
                return true; // Video is playing
                attempts++;
                await new Promise((resolve)=>setTimeout(resolve, interval)); // Wait before retrying
            }
            //console.log(`Vimeo video is not playing after ${maxAttempts} attempts: ${iframe.src}`);
            return false; // Default to not playing if state doesn't stabilize
        } catch (error) {
            return false;
        }
    }
    // Check if YouTube video is playing
    async isYouTubePlaying(iframe) {
        const player = this.youtubePlayers.get(iframe);
        if (player) {
            const state = player.getPlayerState();
            return state === YT.PlayerState.PLAYING;
        }
        return false;
    }
    // Get or create Vimeo player
    getVimeoPlayer(iframe) {
        if (typeof Vimeo === "undefined" || !Vimeo?.Player) return null;
        if (!this.vimeoPlayers.has(iframe)) try {
            const player = new Vimeo.Player(iframe);
            this.vimeoPlayers.set(iframe, player);
        } catch (e) {
            return null;
        }
        return this.vimeoPlayers.get(iframe);
    }
    discardVimeoPlayer(iframe) {
        const player = this.vimeoPlayers.get(iframe);
        this.vimeoPlayers.delete(iframe);
        if (player && typeof player.destroy === "function") player.destroy().catch(()=>{});
    }
    // Get or create YouTube player
    getYouTubePlayer(iframe) {
        return this.youtubePlayers.get(iframe);
    }
}
const $98d11cac84a4afb7$var$videoUtils = new $98d11cac84a4afb7$var$VideoUtils();
var $98d11cac84a4afb7$export$2e2bcd8739ae039 = $98d11cac84a4afb7$var$videoUtils;

});


var $d7rjb = parcelRequire("d7rjb");
const $ca8c6e7f6bc139da$var$SM = 576;
const $ca8c6e7f6bc139da$var$LG = 992;
const $ca8c6e7f6bc139da$var$parseVideo = (url)=>{
    if (!url) return null;
    let match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (match) return {
        type: "vimeo",
        id: match[1]
    };
    match = url.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|embed)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/);
    if (match) return {
        type: "youtube",
        id: match[1]
    };
    if (/\.(mp4|webm|ogg)(\?|$)/i.test(url) || url.indexOf("/progressive_redirect/") !== -1) return {
        type: "html5",
        url: url
    };
    return {
        type: "unknown",
        url: url
    };
};
const $ca8c6e7f6bc139da$var$columnCount = ()=>{
    const width = window.innerWidth;
    if (width >= $ca8c6e7f6bc139da$var$LG) return 4;
    if (width >= $ca8c6e7f6bc139da$var$SM) return 2;
    return 1;
};
const $ca8c6e7f6bc139da$var$prefersReducedMotion = ()=>window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $ca8c6e7f6bc139da$var$mediaEl = (panel)=>panel.querySelector(".ldc-eg__media--video");
const $ca8c6e7f6bc139da$var$setMediaPlaying = (panel, isPlaying)=>{
    const media = $ca8c6e7f6bc139da$var$mediaEl(panel);
    if (media) media.classList.toggle("is-playing", isPlaying);
};
const $ca8c6e7f6bc139da$var$pauseInline = async (panel)=>{
    if (!panel) return;
    const player = panel.querySelector(".ldc-eg__player");
    if (!player) return;
    const video = player.querySelector("video");
    const iframe = player.querySelector("iframe");
    if (video) video.pause();
    if (iframe) {
        if (iframe.src.includes("vimeo.com")) try {
            await (0, $d7rjb.default).pauseVimeo(iframe);
        } catch (e) {
        /* ignore */ }
        else if (iframe.src.includes("youtube.com")) try {
            await (0, $d7rjb.default).pauseYouTube(iframe);
        } catch (e) {
        /* ignore */ }
    }
    player.innerHTML = "";
    player.setAttribute("hidden", "");
    $ca8c6e7f6bc139da$var$setMediaPlaying(panel, false);
};
const $ca8c6e7f6bc139da$var$injectInlinePlayer = async (panel)=>{
    const url = panel.getAttribute("data-eg-video") || "";
    const parsed = $ca8c6e7f6bc139da$var$parseVideo(url);
    const player = panel.querySelector(".ldc-eg__player");
    if (!parsed || !player) return;
    player.removeAttribute("hidden");
    player.innerHTML = "";
    const id = `ldc-eg-player-${Math.random().toString(36).slice(2, 9)}`;
    if (parsed.type === "vimeo") {
        const iframe = document.createElement("iframe");
        iframe.id = id;
        iframe.className = "ldc-eg__iframe";
        iframe.setAttribute("loading", "lazy");
        iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
        iframe.setAttribute("allowfullscreen", "");
        iframe.src = `https://player.vimeo.com/video/${parsed.id}?autoplay=1&controls=1`;
        player.appendChild(iframe);
        try {
            await (0, $d7rjb.default).loadVimeoAPI();
            await (0, $d7rjb.default).playAndControlVimeo(iframe);
        } catch (e) {
        /* iframe may still play */ }
        $ca8c6e7f6bc139da$var$setMediaPlaying(panel, true);
        return;
    }
    if (parsed.type === "youtube") {
        const iframe = document.createElement("iframe");
        iframe.id = id;
        iframe.className = "ldc-eg__iframe";
        iframe.setAttribute("loading", "lazy");
        iframe.setAttribute("allow", "accelerometer; autoplay; fullscreen; picture-in-picture");
        iframe.setAttribute("allowfullscreen", "");
        iframe.src = `https://www.youtube.com/embed/${parsed.id}?autoplay=1&enablejsapi=1`;
        player.appendChild(iframe);
        try {
            await (0, $d7rjb.default).playYouTube(iframe);
        } catch (e) {
        /* ignore */ }
        $ca8c6e7f6bc139da$var$setMediaPlaying(panel, true);
        return;
    }
    if (parsed.type === "html5") {
        const video = document.createElement("video");
        video.id = id;
        video.className = "ldc-eg__html5";
        video.setAttribute("playsinline", "");
        video.setAttribute("controls", "");
        video.src = parsed.url;
        player.appendChild(video);
        try {
            await video.play();
        } catch (e) {
        /* autoplay blocked */ }
        $ca8c6e7f6bc139da$var$setMediaPlaying(panel, true);
    }
};
const $ca8c6e7f6bc139da$var$openLightbox = (panel)=>{
    const link = panel.querySelector("a.ldc-eg__lightbox");
    if (link) {
        link.click();
        return;
    }
    const url = panel.getAttribute("data-eg-video");
    if (url && window.jQuery && window.jQuery.fancybox) window.jQuery.fancybox.open({
        src: url,
        type: "iframe"
    });
};
const $ca8c6e7f6bc139da$var$expandableGrid = (root)=>{
    const grid = root.querySelector(".ldc-eg__grid");
    if (!grid) return;
    let openPanel = null;
    const fillers = [];
    const cells = ()=>Array.from(grid.querySelectorAll(".ldc-eg__cell"));
    const panels = ()=>Array.from(grid.querySelectorAll(".ldc-eg__panel"));
    const syncFillers = ()=>{
        const cols = $ca8c6e7f6bc139da$var$columnCount();
        const count = cells().length;
        const remainder = count % cols;
        const needed = remainder === 0 ? 0 : cols - remainder;
        while(fillers.length > needed){
            const node = fillers.pop();
            node.remove();
        }
        while(fillers.length < needed){
            const filler = document.createElement("div");
            filler.className = "ldc-eg__filler";
            filler.setAttribute("aria-hidden", "true");
            grid.appendChild(filler);
            fillers.push(filler);
        }
        fillers.forEach((filler, i)=>{
            filler.style.order = String((count + i) * 10);
        });
        if (openPanel) placePanel(openPanel);
    };
    const placePanel = (panel)=>{
        const cols = $ca8c6e7f6bc139da$var$columnCount();
        const index = Number(panel.getAttribute("data-eg-index") || 0);
        const rowStart = Math.floor(index / cols) * cols;
        const panelOrder = (rowStart + cols) * 10 - 5;
        panel.style.order = String(panelOrder);
    };
    const setExpanded = (panel, expanded)=>{
        const index = panel.getAttribute("data-eg-index");
        const cell = grid.querySelector(`.ldc-eg__cell[data-eg-index="${index}"]`);
        const button = cell ? cell.querySelector(".ldc-eg__expand") : null;
        if (button) button.setAttribute("aria-expanded", expanded ? "true" : "false");
        if (cell) cell.classList.toggle("is-open", expanded);
        panel.hidden = !expanded;
        panel.classList.toggle("is-open", expanded);
    };
    const closePanel = async (panel)=>{
        if (!panel || panel.hidden) return;
        await $ca8c6e7f6bc139da$var$pauseInline(panel);
        setExpanded(panel, false);
        if (openPanel === panel) openPanel = null;
    };
    const openPanelAt = async (panel, { playInline: playInline = false } = {})=>{
        if (openPanel && openPanel !== panel) await closePanel(openPanel);
        placePanel(panel);
        setExpanded(panel, true);
        openPanel = panel;
        if (!$ca8c6e7f6bc139da$var$prefersReducedMotion()) panel.scrollIntoView({
            block: "nearest",
            behavior: "smooth"
        });
        if (playInline && panel.getAttribute("data-eg-play-mode") === "inline") await $ca8c6e7f6bc139da$var$injectInlinePlayer(panel);
    };
    const togglePanel = async (panel)=>{
        if (!panel.hidden) {
            await closePanel(panel);
            return;
        }
        await openPanelAt(panel);
    };
    root.addEventListener("click", async (event)=>{
        const watch = event.target.closest("[data-eg-watch]");
        if (watch && root.contains(watch)) {
            event.preventDefault();
            event.stopPropagation();
            const cell = watch.closest(".ldc-eg__cell");
            const index = cell && cell.getAttribute("data-eg-index");
            const panel = index != null ? grid.querySelector(`.ldc-eg__panel[data-eg-index="${index}"]`) : null;
            if (!panel) return;
            const mode = watch.getAttribute("data-eg-play-mode") || panel.getAttribute("data-eg-play-mode");
            if (mode === "inline") await openPanelAt(panel, {
                playInline: true
            });
            else $ca8c6e7f6bc139da$var$openLightbox(panel);
            return;
        }
        const inlinePlay = event.target.closest("[data-eg-inline-play]");
        if (inlinePlay && root.contains(inlinePlay)) {
            event.preventDefault();
            const panel = inlinePlay.closest(".ldc-eg__panel");
            if (!panel) return;
            const player = panel.querySelector(".ldc-eg__player");
            if (player && !player.hasAttribute("hidden") && player.innerHTML.trim() !== "") {
                await $ca8c6e7f6bc139da$var$pauseInline(panel);
                return;
            }
            await $ca8c6e7f6bc139da$var$injectInlinePlayer(panel);
            return;
        }
        const closeBtn = event.target.closest("[data-eg-close]");
        if (closeBtn && root.contains(closeBtn)) {
            event.preventDefault();
            const panel = closeBtn.closest(".ldc-eg__panel");
            if (!panel) return;
            const index = panel.getAttribute("data-eg-index");
            await closePanel(panel);
            const cell = index != null ? grid.querySelector(`.ldc-eg__cell[data-eg-index="${index}"]`) : null;
            const expand = cell ? cell.querySelector(".ldc-eg__expand") : null;
            if (expand) expand.focus();
            return;
        }
        const cell = event.target.closest(".ldc-eg__cell");
        if (cell && root.contains(cell)) {
            const index = cell.getAttribute("data-eg-index");
            const panel = index != null ? grid.querySelector(`.ldc-eg__panel[data-eg-index="${index}"]`) : null;
            if (panel) await togglePanel(panel);
        }
    });
    document.addEventListener("keydown", async (event)=>{
        if (event.key === "Escape" && openPanel) await closePanel(openPanel);
    });
    let resizeTimer = 0;
    window.addEventListener("resize", ()=>{
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(()=>{
            syncFillers();
        }, 150);
    });
    syncFillers();
};
const $ca8c6e7f6bc139da$var$init = ()=>{
    document.querySelectorAll(".block-expandable-grid").forEach((block)=>{
        if (block.dataset.egReady) return;
        block.dataset.egReady = "1";
        $ca8c6e7f6bc139da$var$expandableGrid(block);
    });
};
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $ca8c6e7f6bc139da$var$init);
else $ca8c6e7f6bc139da$var$init();

})();
//# sourceMappingURL=expandable-grid.js.map
